import * as Sentry from '@sentry/react';

export const handleGeneralError = (error: unknown, info: unknown) => {
  console.error('Handling general error', error, info);
  Sentry.captureException(error);
};
